import { environment } from '@/environments/environment';
import { EnvironmentInterface } from '@/environments/interfaces/environment.interface';

const getUserLocale = () => {
  const defaultLang = (environment as EnvironmentInterface).language;
  const availableLanguage = ['en', 'nl'];

  const userLocale = navigator.language || defaultLang;
  const userLang = userLocale.split('-')[0].toLowerCase();

  const isAvailable = availableLanguage.includes(userLang);

  return isAvailable ? userLang : defaultLang;
};

export { getUserLocale };
